import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function updateUsername(userId, userName) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      UserId: userId,
      NewUserName: userName,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/userprofile",
    options
  );

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
